module.exports = __webpack_public_path__ + "statics/img/cate1-4@2x.ee98919c.png";